import update from 'immutability-helper';
import moment from 'moment';

export default function filterFeatures(state, action) {
  const startDate = moment(action.startDate);
  const endDate = moment(action.endDate);
  const results = state.features.filter(feature => {
    const featureDate = moment(feature.properties.timestamp);

    if (featureDate >= startDate && featureDate <= endDate) {
      return feature;
    }
  });

  return update(state, {
    filteredFeatures: {
      $set: results,
    },
  });
}
